import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import GET_GSS_STUDENT_SETTINGS from 'graph/settings/gss/get-gss-student-settings-query';
import GET_GSS_CLASSROOM_SETTINGS from 'graph/settings/gss/get-gss-classroom-settings-query';
import { Student } from 'types/schema-generated-types';
import LetterNumberOrder from './CharacterOrder';
import LocaleSetting from './LocaleSetting';

interface GssSettingsProps {
  classroomId: number;
  student: Student;
  productCurriculumCode: string;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const StudentGssSettings: FC<GssSettingsProps> = ({
  student,
  classroomId,
  expanded,
  handleChangeExpanded
}) => {
  const { id: studentId } = student;
  const { data: classroomData, loading: classroomLoading } = useQuery(GET_GSS_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    }
  });
  const { data: studentData, loading: studentLoading } = useQuery(GET_GSS_STUDENT_SETTINGS, {
    variables: {
      where: {
        studentId: Number(studentId)
      }
    }
  });

  return (
    <PageContainer loading={classroomLoading || studentLoading}>
      <LetterNumberOrder
        panel="characterOrder"
        student={student}
        setting={studentData?.gssStudentSettings.characterOrder}
        classroomSetting={classroomData?.gssClassroomSettings.characterOrder}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
      {/* <LeftHandedness
        student={student}
        setting={studentData?.gssStudentSettings.handedness}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      /> */}
      <LocaleSetting
        panel="locale"
        student={student}
        setting={studentData?.gssStudentSettings.locale}
        classroomSetting={classroomData?.gssClassroomSettings.locale}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default StudentGssSettings;
